import styled from "@emotion/styled";

export const TabList = styled.div({
  a: {
    color: "white",
  },
});
